export default __webpack_public_path__ + "assets/pix-icon-component.254b9093.svg";